import React from 'react'
import { Badge, BadgeColor } from '@pandiafi/design-system'

interface ComingSoonBadgeProps {
  label: string
}

export const ComingSoonBadge: React.FC<ComingSoonBadgeProps> = ({ label }) => {
  return (
    <Badge
      className="uppercase text-xs font-medium px-2 py-0.5"
      textColor={BadgeColor.GRAY}
      color={BadgeColor.GRAY}
    >
      {label}
    </Badge>
  )
}
